import { render, staticRenderFns } from "./FooterSalvi.vue?vue&type=template&id=d71a509a&"
import script from "./FooterSalvi.vue?vue&type=script&lang=js&"
export * from "./FooterSalvi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports